import { toLower } from "lodash-es";

const filters = document.querySelectorAll('.attribute-filter');
if(filters) {
    // filter data
    let data = {}

    // add event listener to all product filters
    filters.forEach((filter) => {
        filter.addEventListener('change', filterAttributes)
    })

    function inspBeforeFilter() {
        filters.forEach((filter) => {
            let tax = filter.dataset.tax
            data[tax] = []
        });
    }

    function filterAttributes() {
        // ajax loader
        inspBeforeFilter()

        filters.forEach((filter) => {
            // Build filter 
            let term = filter.value
            let tax = filter.dataset.tax

            if(filter.checked) {
                data[tax].push(term)
            }
        });

        let params = ''
        let currentUrl = window.location.href

        // for (const [key, value] of Object.entries(data)) {
        //     if(value.length > 0) {
        //         let param
        //         console.log(`${key}: ${value}`);
        //         if(Object.keys(data)[0] === key) {
        //             // if this paramater is the first key, prepend ?
        //             param = '?filter_'+key+'='+value
        //             params = params + param
        //         } else {
        //             // otherwise prepend &
        //             param = '&filter_'+key+'='+value
        //             params = params + param
        //         }
        //     }
        // }

        const separator = currentUrl.indexOf('?') !== -1 ? "&" : "?"

        for (const [key, value] of Object.entries(data)) {
            let filter_key = 'filter_'+key
            const re = new RegExp("([?&])" + filter_key + "=.*?(&|$)", "i")
            if(value.length > 0) {
                if (currentUrl.match(re)) {
                    params = currentUrl.replace(re, '$1' + filter_key + "=" + value + '$2');
                }
                else {
                    params = currentUrl + separator + filter_key + "=" + value;
                }
            }
        }


        console.log(params);

        if(currentUrl.includes('page/')) {
            // currentUrl.replace(/page\/([0-9]+)/, '');
            let newURL = currentUrl.replace(/\/page\/([0-9]+)/, '')
            // replace original object with new replaced string
            window.history.replaceState({}, null, newURL)
            // replace now current url object with changed params
            window.history.replaceState({}, null, params)
        } else {
            window.history.replaceState({}, null, params)
        }

        $('ul.products').load(location.href + " ul.products")

    }
}